module.exports = __webpack_public_path__ + "c561c72332cb8fae1ca9a7565bc7e94e.png";